import { createContext, useContext, useState, useCallback } from "react";
import { STRINGS, CATEGORY_PT } from "../lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("vessel_lang") || "en");

  const setLang = useCallback((l) => {
    localStorage.setItem("vessel_lang", l);
    setLangState(l);
  }, []);

  const t = useCallback((key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key, [lang]);

  // pick a translated DB field: field + "_pt" when pt (falls back to base)
  const L = useCallback(
    (obj, field) => {
      if (!obj) return "";
      if (lang === "pt") return obj[`${field}_pt`] || obj[field] || "";
      return obj[field] || "";
    },
    [lang]
  );

  const tc = useCallback((cat) => (lang === "pt" ? CATEGORY_PT[cat] || cat : cat), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, L, tc }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
